<template>
    <div class="">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="danger" @click="Delete('')">批量删除</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">新增配置</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" @selection-change="TabChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="field_label" label="字段名" min-width="100"></el-table-column>
            <el-table-column prop="placeholder" label="提示语" min-width="100"></el-table-column>
            <el-table-column prop="field_type" label="类型" min-width="100">
                <template slot-scope="scope" v-if="FoldList">
                    <div>{{getTypeLabel(scope.row.field_type)}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="group_names" label="是否使用" min-width="100"></el-table-column>
            <el-table-column prop="is_required" label="是否必填" min-width="100">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.is_required">是</el-tag>
                    <el-tag type="info" v-else>否</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="is_visible_to_expert" label="专家是否可见" min-width="100">
                <template slot-scope="scope">
                    <el-tag type="success" v-if="scope.row.is_visible_to_expert">是</el-tag>
                    <el-tag type="info" v-else>否</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="field_options" label="副值" min-width="100">
                <template slot-scope="scope">
                    <div class="BtnHead FlexWrap" v-if="scope.row.field_options && scope.row.field_type!='cascader'">
                        <el-tag v-for="(item,index) in scope.row.field_options" :key="index">{{item.label}}</el-tag>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" min-width="100">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ddd"
                    :active-value="1" :inactive-value="0" @change="ToggleStatus(scope.row)" />
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="120" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i class="NavIcon el-icon-edit"@click="ToggleDig(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="删除" placement="top-start">                        
                        <i class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>                    
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <el-dialog :title="Type=='Add'?'新增配置':'修改配置'" :visible.sync="NewData.NewBlon" width="40%" class="BorderRadius">
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">字段名：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入字段名" v-model="NewData.field_label"></el-input>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">提示语：</div>
                    <el-input class="Wid" size="medium" placeholder="请输入提示语" v-model="NewData.placeholder"></el-input>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">类型：</div>
                    <el-select class="Wid" size="medium"  v-model="NewData.field_type" placeholder="请选择类型" @change="SeleChange">
                          <el-option v-for="item in FoldList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">验证类型：</div>
                    <el-select class="Wid" clearable size="medium"  v-model="NewData.validation_type" placeholder="请选择验证类型">
                          <el-option v-for="item in RuleList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="DigItem JusCen" v-if="NewData.field_type =='file'">
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">模板文件：</div>
                    <el-upload v-if="!NewData.moban_url" action="none" :show-file-list="false" :http-request="(res) => UploadFlie(res)">
                        <el-button v-throttle class="BgColor" size="small" type="info">上传</el-button>
                        <span> 文件上传限制500M以内</span>
                    </el-upload>
                    <div v-else>
                        <span>文件</span>
                        <el-tooltip effect="dark" content="查看文件" placement="top-start">
                            <i class="NavIcon el-icon-view" @click="LockUrl(NewData.moban_url)"></i>
                        </el-tooltip>
                        <el-tooltip effect="dark" content="删除文件" placement="top-start">
                            <i class="NavIcon el-icon-delete" @click="NewData.moban_url = ''"></i>
                        </el-tooltip>
                    </div>
                </div>
            </div>
            <div class="DigItem" v-if="NewData.field_type=='select' || NewData.field_type=='radio'|| NewData.field_type=='checkbox'">
                <div class="DigItemTit">副值：</div>
                <div class="DigItem">
                    <div class="DisPos" v-for="(item,index) in NewData.field_options" :key="index" >
                        <el-input class="Wid" size="medium" v-model="item.label"></el-input>
                        <i class="DisAbs el-icon-error" v-if="index!=0" @click="FlodRemove(index)"></i>
                    </div>
                    <el-button v-throttle size="mini" type="primary" icon="el-icon-plus" circle @click="FlodAdd"></el-button>
                </div>
            </div>
            <div class="DigItem" v-if="NewData.field_type=='cascader'">
                <div class="DigItemTit">联动配置：</div>
                <div class="Wid">
                    <div v-for="(item,index) in NewData.field_options" :key="index" class="">
                        <div class="DigItem">
                            <div>一级名称：</div>
                            <el-input class="Wid120" size="medium" v-model="item.label"></el-input>
                            <el-button v-if="index==0" v-throttle size="mini" type="primary" icon="el-icon-plus" circle @click="FlodAdd"></el-button>
                            <el-button v-else v-throttle size="mini" type="danger" icon="el-icon-minus" circle @click="FlodRemove(index)"></el-button>
                        </div>
                        <div class="DigItem">
                            <div>二级名称：</div>
                            <div class="DigItem">
                                <div class="DisPos" v-for="(items,indexs) in item.children" :key="index+':'+indexs" >
                                    <el-input class="Wid" size="medium" v-model="items.label"></el-input>
                                    <i class="DisAbs el-icon-error" v-if="indexs!=0" @click="FlodChildRemove(index,indexs)"></i>
                                </div>
                                <el-button v-throttle size="mini" type="primary" icon="el-icon-plus" circle @click="FlodChildAdd(index)"></el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="DigItem JusCen">
                <div class="DigItem MarBom0" v-if="">
                    <div class="DigItemTit">是否必填：</div>
                    <el-switch class="Wid" v-model="NewData.is_required" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">专家是否可见：</div>
                    <el-switch class="Wid" v-model="NewData.is_visible_to_expert" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
                <div class="DigItem MarBom0">
                    <div class="DigItemTit">用户是否可见：</div>
                    <el-switch class="Wid" v-model="NewData.is_user_view" active-color="#13ce66" inactive-color="#ddd"
                        :active-value="1" :inactive-value="0"/>
                </div>
            </div>
            <div class="DigItem">
                <div class="DigItemTit">状态：</div>
                <el-switch class="Wid" v-model="NewData.status" active-color="#13ce66" inactive-color="#ddd" 
                    :active-value="1" :inactive-value="0"/>
            </div>
            <div slot="footer">
                <el-button v-throttle size="small" @click="$Tools.ResetData(NewData)">取消</el-button>
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="SucData">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SearchVal:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                SeleId:[],
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    field_label:"",
                    field_type:"",
                    placeholder:"",
                    field_options:"",
                    validation_type:"",
                    moban_url:"",
                    is_required:false,
                    is_visible_to_expert:1,
                    is_user_view:1,
                    status:false,
                },
                FoldList:"",
                RuleList:"",
            };
        },
        mounted() {
            this.GetData();
            this.GetFold();
            this.GetRule();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/info_collection_item/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetFold(){
                this.$get('/admin/info_collection_item/getFieldTypes',).then(res=>{
                    if(res){
                        this.FoldList = res.data.filter(item => item.value !== "multi_file");
                    }
                })
            },
            GetRule(){
                this.$get('/admin/validation_types/index',).then(res=>{
                    if(res){
                        this.RuleList = res.data;
                    }
                })
            },
            getTypeLabel(s){
                const found = this.FoldList.find(item => item.value == s);
                return found ? found.label : s;
            },
            TabChange(val){
                this.SeleId = val.map(item => item.id);
            },
            ToggleStatus(row){
                this.$post('/admin/info_collection_item/toggleStatus',{
                    ids:[row.id],
                    status:row.status,
                }).then(res=>{
                    if(res){
                        this.$message.success("修改成功!");
                        this.GetData();
                    }
                })
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type='Edi';
                    this.NewData.id = row.id;
                    this.NewData.field_label = row.field_label;
                    this.NewData.field_type = row.field_type;
                    this.NewData.validation_type = row.validation_type;
                    this.NewData.placeholder = row.placeholder;
                    this.NewData.field_options = row.field_options;
                    this.NewData.is_required = row.is_required;
                    this.NewData.status = row.status;
                    this.NewData.moban_url = row.moban_url;
                    this.NewData.is_visible_to_expert = row.is_visible_to_expert;
                    this.NewData.is_user_view = row.is_user_view;
                }else{
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            SucData(){
                var Query = JSON.parse(JSON.stringify(this.NewData))
                if(Query.field_label == ""){
                    this.$message.error("请填写字段名或类型");
                    return ;
                }
                if(Query.field_type=='cascader'){
                    Query.field_options = JSON.stringify(Query.field_options);
                }
                var url = this.Type=='Add'?'/admin/info_collection_item/save':'/admin/info_collection_item/update';
                this.$post(url,Query).then(res=>{
                    if(res){
                        this.$Tools.ResetData(this.NewData)
                        this.$message.success(res.msg);
                        this.GetData();
                    }
                })
            },
            Delete(id) {
                var Ids = id!=""?[id]:this.SeleId;
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/admin/info_collection_item/delete',{
                        ids:Ids,
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SeleChange(val){
                if(val=='select' || val=='radio'|| val=='checkbox'){
                    this.NewData.field_options = [{"value": ""}];
                }else if(val=='cascader'){
                    this.NewData.field_options = [{"label":"","children":[{"label":""}]}];
                }else{
                    this.NewData.field_options = "";
                }
            },
            FlodAdd(){
                if(this.NewData.field_type == 'cascader'){
                    this.NewData.field_options.push({"label":"","children":[{"label":""}]});
                }else{
                    this.NewData.field_options.push({"value": ""});
                }
            },
            FlodRemove(i){
                this.NewData.field_options.splice(i,1);
            },
            FlodChildAdd(i){
                this.NewData.field_options[i].children.push({"label": ""});
            },
            FlodChildRemove(i,is){
                this.NewData.field_options[i].children.splice(is,1);
            },
            UploadFlie(row){
                var file = row.file;
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                const MAX_SIZE = 100 * 1024 * 1024 * 5;
                const fileSize = file.size;
                if (fileSize > MAX_SIZE) {
                    this.$message.error(`文件大小超出限制！最大支持500M，当前文件大小：${(fileSize / 1024 / 1024).toFixed(2)}M`);
                    return;
                }
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    this.$post("/common/upload/image",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.NewData.moban_url = res.data.url;
                    })
                } catch (error) {
                    loading.close();
                }
            },
            LockUrl(url){
                var str = "";
                if(url.indexOf('http') == 0){
                    str = url;
                }else{
                    str = this.$Tools.ServeUrl()+url;
                }
                window.open(str)
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .DigItemDis{
        display: flex;
        align-items: center;
    }
    .DisPos{
        width: 85px;
        position: relative;
        margin-right: 10px;
        margin-bottom: 10px;
    }
    .DisAbs{
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        color: #d51938;
    }
</style>
